import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { InformationCard } from 'src/components/information-card';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3, spacing4, spacing5 } from 'src/styles/spacing';

export const StyledCard = styled(InformationCard)`
  margin-bottom: ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing4};
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing4};
  }
`;

export const StyledSummary = styled.div`
  padding: ${spacing2} 0;
  border-bottom: 1px solid ${colorSecondary200};
  border-top: 1px solid ${colorSecondary200};

  @media (min-width: ${breakpointTablet}) {
    padding: ${spacing5} 0 0;
    border-bottom: 0;
  }
`;

export const StyledLabel = styled(Typography)`
  padding-right: ${spacing1};
  font-weight: normal;
`;

export const StyledValue = styled(Typography)`
  font-weight: normal;
`;

export const StyledSummaryRow = styled.div`
  padding-bottom: ${spacing1};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &:first-child {
    ${StyledLabel} {
      font-weight: bold;
    }

    ${StyledValue} {
      font-weight: bold;
    }
  }

  &:last-child {
    padding-bottom: 0;
  }

  @media (min-width: ${breakpointTablet}) {
    padding-bottom: ${spacing2};
  }
`;
